import './floorplan-tabs.scss';

import Pricelist from '../../modules/pricelist/pricelist';
import Component from '../component/component';

export default class FloorplanTabs extends Component {

    static initSelector: string = '.floorplan-tabs';

    constructor(target: HTMLElement) {
        super(target);
        this.element.find('.floorplan__overlay[data-name], .floorplan__overlay[data-id]').each((index: number, element: HTMLElement) => Pricelist.initTooltip(element));
    }

}
